import React from "react";
import ReactDOM from "react-dom";
import App from "./app";
import "materialize-css/dist/css/materialize.min.css";

ReactDOM.render(<App />, document.getElementById("root"));
